/* esm.sh - react@18.2.0 */
export * from "https://esm.sh/stable/react@18.2.0/denonext/react.mjs";
export { default } from "https://esm.sh/stable/react@18.2.0/denonext/react.mjs";
